import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38902ad8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "selected" }

import { computed, onMounted } from 'vue'
import { useStoreAuth } from '@/store/auth'
import { DigUiPopup } from '@digithia/ui'
import { countries } from './BaseLocale'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseLocaleSelect',
  setup(__props) {

const storeAuth = useStoreAuth()

let popupLang: DigUiPopup

onMounted(() => {
  popupLang = document.querySelector('#popup-lang') as DigUiPopup
})

const selectedFlag = computed(() => {
  const flag = countries.find((c) => c.lang === storeAuth.lang)?.flag
  return flag
})

const open = () => {
  popupLang.trigger()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "locale-select",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (open()))
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(selectedFlag)), 1)
  ]))
}
}

})